const SvgExpandLess = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m16 12.943-7.528 7.528-.943-.943L16 11.057l8.471 8.471-.943.943-7.529-7.528z" />
  </svg>;
export default SvgExpandLess;